import styled from 'styled-components';
import { spacing } from '@config/spacing';
import { app } from '@config/constants';
import { media } from '@config/breakpoints';

/* Transparent: the page stands on the water (`WaterBackground`), as the
   app's pages do. A whole-page glass here would smear the caustics and
   re-blur the full viewport on every frame of the water; the cards and
   the header carry their own glass. */
export const PageWrapper = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  position: relative;
  isolation: isolate;
`;

export const MainContent = styled.main`
  flex: 1;
`;

export const Container = styled.div`
  width: min(100%, var(--max-content-width, ${app.maxContentWidth}));
  margin: 0 auto;
  padding: 0 ${spacing.xl};
  position: relative;
  z-index: 1;

  ${media.md} {
    padding: 0 ${spacing['2xl']};
  }
`;
